import { render } from "./attendance-regularizations.vue?vue&type=template&id=593267e0&scoped=true"
import script from "./attendance-regularizations.vue?vue&type=script&lang=js"
export * from "./attendance-regularizations.vue?vue&type=script&lang=js"

import "./attendance-regularizations.vue?vue&type=style&index=0&id=593267e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593267e0"]])

export default __exports__